/**
 * @Description
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import Footer from '../Footer';
// import PPTBarChart from '../BarChart';
import PPTPieChart from '../PieChart';

const PageThree:FC<any> = ({
  peopleInfoVO,
  surroundingInfoVO,
  rangeName,
  qrCode,
  peopleStatisticsVO
}) => {

  const SurroundingPieChartData = useMemo(() => {
    // const { fomatVOList = [] } = surroundingInfoVO;
    const dataList = surroundingInfoVO?.fomatVOList?.map((item: any) => {
      return { name: item?.commercialName, value: item?.num };
    }) || [];

    const preData = dataList?.slice(0, 7);

    let otherValue = 0;

    for (let i = 7; i < dataList.length; i++) {
      otherValue += dataList[i].value;
    }

    const res = [...preData, { name: '其他', value: otherValue }];

    return res || ([
      { value: 58, name: '商业' },
      { value: 11, name: '银行' },
      { value: 13, name: '住宅' },
      { value: 5, name: '学校' },
      { value: 66, name: '交通' },
      { value: 21, name: '景区' },
      { value: 9, name: '办公' },
      { value: 15, name: '医院' },
    ]);
  }, [surroundingInfoVO]);

  const cardData = useMemo(() => {
    return ([
      { name: '居住人口', vlaue: peopleInfoVO?.peopleNum || '' },
      { name: '占全市人口', vlaue: peopleInfoVO?.peoplePercent || '' },
    ]);
  }, [peopleInfoVO]);

  return (
    <div className={styles['page']}>
      <Header title={`人口规模/周边配套 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['left']}>

          <div className={styles['intro']}>
            <div className={styles['intro-title']}>人口规模</div>

            <div className={styles['intro-content']}>
              {/* 本区域共居住人口共<span className={styles['count']}>19.88</span>万人，人口密度排名全市前<span className={styles['count']}>20%</span>。 */}
              {peopleStatisticsVO?.populationSizeIntroduction || '-'}
            </div>

            <div className={styles['intro-card']}>
              {cardData.map((item, index) => {
                return (
                  <div className={styles['block']} key={index}>
                    <div className={styles['block-value']}>{item.vlaue}</div>
                    <div className={styles['block-name']}>{item.name}</div>
                  </div>
                );
              })}
            </div>

            {/* 0201不上 */}
            {/* <div className={styles['chart']}>
              <div style={{ width: '702px' }}>
                <PPTBarChart
                  width={590}
                  height={380}
                  title='人口密度对比(单位：万人/平方公里)'
                  xAxisData={['所选区域(余杭区)', '全市平均']}
                  needLegend={false}
                  seriesData={[{
                    name: '人口密度对比',
                    data: [2.8, 2.5],
                    itemStyle: {
                      color: '#70C8E4',
                      normal: {
                        label: {
                          show: true,
                          position: 'top',
                          textStyle: {
                            color: '#222222',
                            fontSize: 16,
                            lineHeight: 22
                          }
                        }
                      }
                    },
                    barMaxWidth: 22
                  }]}
                  config={{
                    xAxis: {
                      axisLabel: {
                        color: '#222222',
                        lineHeight: 22,
                        fontSize: 16,
                        fontWeight: 400
                      }
                    }
                  }}
                />

                <div className={styles['chart-title']}>人口密度比对</div>
              </div>
            </div> */}
          </div>
        </div>

        <div className={styles['right']}>
          <div className={styles['intro']}>
            <div className={styles['intro-title']}>
              周边配套
            </div>
            <div className={styles['intro-content']}>
              {/* 区域内配套完善，餐饮<span className={styles['intro-content__count']}>人均消费40元</span>，比余杭区餐饮人均消费高10.12%，<span className={styles['intro-content__count']}>平均房价3.5万/m²</span>，比余杭区平均房价高20%，区域内共<span className={styles['intro-content__count']}> 600 家企业</span>，其中<span className={styles['intro-content__count']}>互联网行业占比最高11%</span>，距离最近地铁站(五常站)步行500米，交通便利。 */}
              {surroundingInfoVO?.introductionNoHousePrice || '-'}
            </div>
          </div>

          <div className={styles['chart']}>
            <div style={{ width: '100%' }}>
              <PPTPieChart
                title='配套数量'
                type='circle'
                height={280}
                seriesData={[{
                  data: SurroundingPieChartData,
                }]}
                config={{
                  legend: {
                    height: 190
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles['footer']}>
        <Footer qrCode={qrCode}/>
      </div>
    </div>
  );
};

export default PageThree;
